import * as actionTypes from '../redux/actionTypes';
import { call, all, put, takeLatest, select, take } from 'redux-saga/effects';
import logger from '../shared/logger';
import config from '../appConfig';
import Http from '../shared/http-service';
import NA_VALUE, { EMPTY_ADDRESS } from '../shared/na';
import userService from '../shared/user-service';
import { convertFirstLetterInArray, getUpdatedRoosterDays, getVanAvailableDays } from '../join-commute/helpers/commonHelper';
import { cancelReasons } from "./components/cancelReasons";
import { getActiveDaysFromRoosterDays, getPackageFromDays } from '../join-commute/helpers/vanHelpers';
import profileService from '../login/profileService';
import { isEmpty } from 'lodash';
import dateUtility from '../shared/dateUtility';

const subscriptionURL = `${config.kongApiBaseUrl}/user/participant/subscription`;
const driver_url = `${config.kongApiBaseUrl}/driver`;
const coordApplication = `${config.kongApiBaseUrl}/user/participant/contract/v2`;

export default function* () {
  yield takeLatest(actionTypes.USER_PROFILE_LOADING, loadProfileData);
  yield takeLatest(
    actionTypes.USER_PERSONAL_INFO_LOADING,
    loadPersonalInfoData
  );
  yield takeLatest(actionTypes.PERSONAL_INFO_SAVING, savePersonalInfo);
  yield takeLatest(actionTypes.LICENSE_SAVING, saveLicense);
  yield takeLatest(actionTypes.LEAVE_VANPOOL, leaveVanpool);
  yield takeLatest(actionTypes.TOGGLE_PREFERENCE, togglePreference);
  yield takeLatest(actionTypes.STATES_LOADING, loadStates);
  yield takeLatest(actionTypes.GET_VANPOOL_RATES_INFO, getVanpoolRatesInfo);
  yield takeLatest(actionTypes.APPLY_TO_DRIVE, applyToDrive);
  yield takeLatest(actionTypes.UPDATE_LICENSE, updateLicense);
  yield takeLatest(actionTypes.CANCEL_SUBSCRIPTION, cancelSubscription);
  yield takeLatest(actionTypes.CHANGE_COMMUTE_DAYS, changeCommuteDays);
  yield takeLatest(actionTypes.GET_SUBSCRIPTION_DETAILS, getSubscriptionDetails);
  yield takeLatest(actionTypes.CHANGE_SUBSCRIPTION_TYPE, changeSubscriptionType);
  yield takeLatest(actionTypes.SUMBIT_SUBSCRIPTION_COORDINATOR_APPLICATION, submitCoordinatorApplication);
  yield takeLatest(actionTypes.SAVE_USER_COMMUTE_PROFILE, saveUserCommuteProfile);
  yield takeLatest(actionTypes.REFRESH_AUTHENTICATION_AND_REDIRECT, refreshAuthentication);
  yield takeLatest(actionTypes.CHECK_SECONDARY_CARD_REQUIRED, checkSecondaryCardIsRequired);
  yield takeLatest(actionTypes.LOAD_PROFILE_AFTER_LICENSE_UPDATE, loadDataAfterUpdateLicense);
  yield takeLatest(actionTypes.LOAD_PROFILE_AFTER_PERSONALINFO_UPDATE, loadDataAfterUpdatePersonalInfo);
}


function* savePersonalInfo({ data }) {
  try {
    const { homeAddress, mailingAddress, phone, secondPhone, employeeId, updateEIdFromLogin, updateEIdFromOnboarding } = data;

    phone.isPreferred = true;
    secondPhone.isPreferred = false;

    var response = yield Http.put(`${config.kongApiBaseUrl}/user/profile`, {
      phones: secondPhone.number ? [phone, secondPhone] : [phone],
      homeAddress,
      mailingAddress,
      employeeId
    });

    // yield delay(2000);
    // var response = {
    //   success: true
    // }

    if(response.success) {
      if(updateEIdFromLogin){
        yield put({ type: actionTypes.UPDATE_USER_PROFILE_DATA });
        yield put({ type: actionTypes.EMPLOYERID_UPDATED_SUCCESSFULLY, data: true });
        yield put({ type: actionTypes.SHOW_EMPLOYER_ID_POPUP, data: false });
        yield put({ type: actionTypes.PREVENT_HEADER_EVENTS, data: false });
      } else if(updateEIdFromOnboarding) {
        yield delay(1000);
        yield put({ type: actionTypes.EMPLOYERID_UPDATED_SUCCESSFULLY, data: true });
        yield call(() => loadDataAfterUpdatePersonalInfo());
      } else {
        yield delay(1000);
        yield call(() => loadDataAfterUpdatePersonalInfo());
        yield put({ type: actionTypes.USER_PROFILE_SAVED, data: true });
      }
    } else {
      yield put({ type: actionTypes.EMPLOYERID_UPDATED_FAILURE, data: true });
    }
  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.EMPLOYERID_UPDATED_FAILURE, data: true });
  }
}

function* loadDataAfterUpdateLicense(action) {
  const user = userService.getUserProfile();
  try {
    const profileUrl = `${config.kongApiBaseUrl}/user/profile`;
    const driverUrl = `${config.kongApiBaseUrl}/user/profile/license`;
    let [profile, driverLicense] = yield all([
      call(() => Http.get(profileUrl)),
      call(() => Http.get(driverUrl))
    ]);
    user && user.isInVanpool && put({ type: actionTypes.STATES_LOADING });
    var driver = {
      license: driverLicense &&  `*****${driverLicense.partialLicenseNumber}`,
      state: driverLicense && driverLicense.stateOfIssue
        ? standardizeStateCase(driverLicense.stateOfIssue)
        : '',
      isDriver: profile && profile.roles.driver,
      licenseExpiry: driverLicense && driverLicense.expirationDate,
    };
    yield put({ type: actionTypes.LICENSE_STATUS_LOADED, data: true });
    yield put({
      type: actionTypes.USER_PROFILE_LOADED,
      data: {
        phone: profile.phones ? profile.phones[0] : { number: NA_VALUE },
        secondPhone:
        profile.phones && profile.phones[1]
            ? profile.phones[1]
            : { number: '' },
        homeAddress: profile.homeAddress
          ? {
            ...profile.homeAddress,
            state: standardizeStateCase(profile.homeAddress.state)
          }
          : EMPTY_ADDRESS,
        mailingAddress: profile.mailingAddress
          ? {
            ...profile.mailingAddress,
            state: standardizeStateCase(profile.mailingAddress.state)
          }
          : EMPTY_ADDRESS,
        employee: {
            isEmployeeIdRequired: profile.isEmployeeIdRequired,
            isEmployeeIdMissing: profile.isEmployeeIdMissing,
            employeeId: profile.employeeId,
            employeeIdPattern: profile.employeeIdPattern,
            employeeIdPatternDescription: profile.employeeIdPatternDescription
        },
        driver: driver,
        isDriver: profile && profile.driverStatus && profile.driverStatus.includes('Approved'),
        driverStatus: profile && profile.driverStatus,
        driverMvrStatus: profile && profile.driverMvrStatus,
        driverUpdatedStatus: profile && getDriverStatus(profile.driverStatus),
        isSubscription: user && user.isSubscription,
        roles: profile && profile.roles
      }
    });
  } catch (ex) { }
}

function* loadDataAfterUpdatePersonalInfo(action) {
  const profileUrl = `${config.kongApiBaseUrl}/user/profile`;
  try {
   const profile = yield call(() => Http.get(profileUrl));
   var newData =  {
    phone: profile.phones ? profile.phones[0] : { number: NA_VALUE },
    secondPhone:
    profile.phones && profile.phones[1]
        ? profile.phones[1]
        : { number: '' },
    homeAddress: profile.homeAddress
      ? {
        ...profile.homeAddress,
        state: standardizeStateCase(profile.homeAddress.state)
      }
      : EMPTY_ADDRESS,
    mailingAddress: profile.mailingAddress
      ? {
        ...profile.mailingAddress,
        state: standardizeStateCase(profile.mailingAddress.state)
      }
      : EMPTY_ADDRESS,
    employee: {
        isEmployeeIdRequired: profile.isEmployeeIdRequired,
        isEmployeeIdMissing: profile.isEmployeeIdMissing,
        employeeId: profile.employeeId,
        employeeIdPattern: profile.employeeIdPattern,
        employeeIdPatternDescription: profile.employeeIdPatternDescription
      },
      roles: profile && profile.roles
  }
    yield put({ type: actionTypes.USER_PROFILE_LOADED, data: newData });
  } catch (ex) { }
}

function* loadPersonalInfoData(action) {
  const user = userService.getUserProfile();
  var onlyPersonalProfile = action.onlyPersonalProfile;
  const state = yield select();
  const previousProfile = state.profile;
  var vanpool = state.vanpoolInfo;
  try {
    const profileUrl = `${config.kongApiBaseUrl}/user/profile`;
    const preferenceUrl = `${config.kongApiBaseUrl}/user/participant/profile/preferences`;
    const driverUrl = `${config.kongApiBaseUrl}/user/profile/license`;
    const vanpoolUrl = `${config.kongApiBaseUrl}/vanpools/vanpool`;
    let driver = { partialLicenseNumber: '', stateOfIssue: '' };
    let vanpoolInfo = {};
    let [newProfile, preferences] = yield all([
      call(() => Http.get(profileUrl)),
      call(() => Http.get(preferenceUrl)),
      put({ type: actionTypes.STATES_LOADING })
    ]);
    if(vanpool && !vanpool.loaded){
        vanpool = yield call(() => Http.get(vanpoolUrl));
    }
    if ( onlyPersonalProfile && user && user.isInVanpool && !(newProfile && (newProfile.driverStatus === ""))) {
      try {
        driver = yield call(() => Http.get(driverUrl));
      } catch(exception) {
        logger.log(exception);
      }
    }
    if(onlyPersonalProfile) {
    vanpoolInfo = {
      name: vanpool && vanpool.vanpoolName,
      id: newProfile && newProfile.vanpoolId,
      participant: newProfile && newProfile.participantId,
      role: newProfile && newProfile.roleName,
      status: previousProfile.vanpool.status,
      isAbleToLeave: previousProfile && previousProfile.isAbleToLeaveVanpool,
      matches: vanpool && vanpool.matchCount || 0,
      pickupLocation: previousProfile.commuteDetails && previousProfile.commuteDetails.originAddress,
      dropLocation: previousProfile.commuteDetails && previousProfile.commuteDetails.destinationAddress,
      pickupTime: previousProfile.commuteDetails && previousProfile.commuteDetails.originDepartureTime,
      dropTime: previousProfile.commuteDetails && previousProfile.commuteDetails.originArrivalTime,
      commuteDays: previousProfile.vanpool.commuteDays,
      smallCommuteDays: previousProfile.vanpool.smallCommuteDays,
      vehicleType: vanpool && vanpool.vehicleType,
      vanpoolImage: previousProfile.vanpool.vanpoolImage,
      package: previousProfile.vanpool.package,
      operationalDays: previousProfile.vanpool.operationalDays,
      vanAvailableDays: previousProfile.vanpool.vanAvailableDays,
    },
    driver = {
      license: driver &&  `*****${driver.partialLicenseNumber}`,
      state: driver && driver.stateOfIssue
        ? standardizeStateCase(driver.stateOfIssue)
        : '',
      isDriver: newProfile && newProfile.roles.driver,
      licenseExpiry: driver && driver.expirationDate,
    }
  }
    yield put({
      type: actionTypes.USER_PROFILE_LOADED,
      data: {
        phone: newProfile.phones ? newProfile.phones[0] : { number: NA_VALUE },
        secondPhone:
        newProfile.phones && newProfile.phones[1]
            ? newProfile.phones[1]
            : { number: '' },
        homeAddress: newProfile.homeAddress
          ? {
            ...newProfile.homeAddress,
            state: standardizeStateCase(newProfile.homeAddress.state)
          }
          : EMPTY_ADDRESS,
        mailingAddress: newProfile.mailingAddress
          ? {
            ...newProfile.mailingAddress,
            state: standardizeStateCase(newProfile.mailingAddress.state)
          }
          : EMPTY_ADDRESS,
        employee: {
            isEmployeeIdRequired: newProfile.isEmployeeIdRequired,
            isEmployeeIdMissing: newProfile.isEmployeeIdMissing,
            employeeId: newProfile.employeeId,
            employeeIdPattern: newProfile.employeeIdPattern,
            employeeIdPatternDescription: newProfile.employeeIdPatternDescription
          },
        roles: newProfile && newProfile.roles,
        preferences: preferences.preferences,
        onlyPersonalProfile: action.onlyPersonalProfile,
        vanpool: onlyPersonalProfile ? vanpoolInfo : null,
        driver: onlyPersonalProfile ? driver : null,
        isDriver: newProfile && newProfile.driverStatus && newProfile.driverStatus.includes('Approved'),
        driverStatus: newProfile && newProfile.driverStatus,
        driverMvrStatus: newProfile && newProfile.driverMvrStatus,
        driverUpdatedStatus: newProfile && getDriverStatus(newProfile.driverStatus),
      }
    });

    const updatedAuthProfile = user && newProfile && profileService.addProfilePermissions(user, { ...newProfile, licenseExpiry: driver && driver.licenseExpiry });
    if (updatedAuthProfile) {
      yield put({ type: actionTypes.SET_USER_AUTHORIZATION, data: updatedAuthProfile });
    }
  } catch (ex) { }
}

function* loadProfileData(action) {   //from dashboard or after change/manage subacription.
  const state = yield select();
  var vanpoolInfo = state.vanpoolInfo;
  const fromProfile = action.fromProfile;
  const notFromProfile = action.notFromProfile;
  const loadParticipants = action.loadParticipants;
  try {
    const user = userService.getUserProfile();
    const profileUrl = `${config.kongApiBaseUrl}/user/profile`;
    const driverUrl = `${config.kongApiBaseUrl}/user/profile/license`;
    const vanpoolUrl = `${config.kongApiBaseUrl}/vanpools/vanpool`;
    const preferenceUrl = `${config.kongApiBaseUrl}/user/participant/profile/preferences`;
    const commuteUrl = `${config.kongApiBaseUrl}/user/profile/commuteProfile`;
    const participantsUrl = `${config.kongApiBaseUrl}/vanpools/vanpool/participants`;
    const summaryUrl = `${config.kongApiBaseUrl}/user/participant/monthly/subscription/summary`;
    let vanpool = { vanpoolName: null };
    let driver = { partialLicenseNumber: '', stateOfIssue: '' };

    let [profile, preferences, commuteDetails, participants, subscriptionSummary, subscriptionAPIInfo] = yield all([
      call(() => user && Http.get(profileUrl)),
      call(() => user && fromProfile && Http.get(preferenceUrl)),
      call(() => user && Http.get(commuteUrl)),
      call(() => user && (fromProfile || loadParticipants) && user.isInVanpool && user.vanpoolId && Http.get(participantsUrl)),
      call(() => user && user.isSubscription && user.isInVanpool && user.vanpoolId &&  (action && action.source !== 'joinCommute') && Http.get(summaryUrl)),
      call(() => user && user.isSubscription && user.isInVanpool && user.vanpoolId && (action && action.source !== 'joinCommute')  && Http.get(subscriptionURL)),
      user && user.isInVanpool && fromProfile && put({ type: actionTypes.STATES_LOADING })
    ]);
    if (user && user.isInVanpool && ((vanpoolInfo && !vanpoolInfo.loaded) || fromProfile) ) {
      vanpool = yield call(() => Http.get(vanpoolUrl));
      if (!(profile && (profile.driverStatus === "")) && fromProfile) {
        try {
          driver = yield call(() => Http.get(driverUrl));
        } catch(exception) {
          logger.log(exception);
        }
      }
    }
    const name = profile && (profile.firstName
      ? `${profile.firstName} ${profile.middleName ? profile.middleName[0] + ' ' : ''
      }${profile.lastName}`
      : NA_VALUE);

    const coordinatorStatus =
    profile && profile.coordinatorStatus &&
        !profile.coordinatorStatus.includes('Approved')
        ? `Coordinator ${profile.coordinatorStatus}`
        : '';
    const driverStatus =
    profile && profile.driverStatus && !profile.driverStatus.includes('Approved')
        ? `Driver ${profile.driverStatus}`
        : '';

    const participant = participants ? participants.participants.find(p => p.participantId == profile.participantId) : [];
    let rosterDays = {};
    if(commuteDetails && commuteDetails.commuteDays && commuteDetails.commuteDays.length > 0){
      rosterDays = getUpdatedRoosterDays(commuteDetails.commuteDays, true);
    } else if(subscriptionAPIInfo && subscriptionAPIInfo.participantCommuteDays && !isEmpty(subscriptionAPIInfo.participantCommuteDays)){
      rosterDays = subscriptionAPIInfo.participantCommuteDays;
    }
    const vanAvailableDays = subscriptionAPIInfo && subscriptionAPIInfo.vanpool && subscriptionAPIInfo.vanpool.operationalDays && getVanAvailableDays(subscriptionAPIInfo.vanpool.operationalDays);
    const isVanStartingInFuture = subscriptionAPIInfo && subscriptionAPIInfo.package === null && subscriptionAPIInfo.pendingChange !== null;
    const isVanCancelled = subscriptionAPIInfo && subscriptionAPIInfo.package !== null && subscriptionAPIInfo.pendingChange === null && subscriptionAPIInfo.endDate !== null;
    const presentOrPendingCommuteDays = subscriptionAPIInfo && (subscriptionAPIInfo.package === null && subscriptionAPIInfo.pendingChange ? getActiveDaysFromRoosterDays(subscriptionAPIInfo.pendingChange.participantCommuteDays) : getActiveDaysFromRoosterDays(subscriptionAPIInfo.participantCommuteDays));
    const participantsDays = getActiveDaysFromRoosterDays(rosterDays);
    const pack = (subscriptionAPIInfo && subscriptionAPIInfo.package) || (getPackageFromDays(participantsDays));
    if(profile){
      yield put({
        type: actionTypes.USER_PROFILE_LOADED,
        data: {
          name,
          fname: profile && profile.firstName,
          phone: profile && profile.phones ? profile.phones[0] : { number: NA_VALUE },
          secondPhone:
          profile && profile.phones && profile.phones[1]
              ? profile.phones[1]
              : { number: '' },
          email: profile && profile.emailAddress || NA_VALUE,
          homeAddress: profile && profile.homeAddress
            ? {
              ...profile.homeAddress,
              state: standardizeStateCase(profile.homeAddress.state)
            }
            : EMPTY_ADDRESS,
          mailingAddress: profile && profile.mailingAddress
            ? {
              ...profile.mailingAddress,
              state: standardizeStateCase(profile.mailingAddress.state)
            }
            : EMPTY_ADDRESS,
          addresses: {
            homeAddress: profile && profile.homeAddress,
            mailingAddress: profile && profile.mailingAddress
          },
          vanpoolId: profile && profile.vanpoolId,
          preferences: preferences && preferences.preferences,
          participantId: profile && profile.participantId,
          vanpool: {
            name: vanpool && vanpool.vanpoolName,
            id: profile && profile.vanpoolId,
            participant: profile && profile.participantId,
            role: profile && profile.roleName,
            status: coordinatorStatus && driverStatus && 
              [coordinatorStatus, driverStatus]
                .filter(status => status)
                .join(', ') || 'No Active Applications',
            isAbleToLeave: profile && profile.isAbleToLeaveVanpool,
            matches: vanpool && vanpool.matchCount || 0,
            pickupLocation: commuteDetails && commuteDetails.originAddress,
            dropLocation: commuteDetails &&commuteDetails.destinationAddress,
            pickupTime: commuteDetails && commuteDetails.originDepartureTime,
            dropTime: commuteDetails && commuteDetails.originArrivalTime,
            commuteDays: participantsDays,
            smallCommuteDays: commuteDetails && convertFirstLetterInArray(participantsDays),
            vehicleType: vanpool && vanpool.vehicleType,
            vanpoolImage: vanpool && vanpool.carClassImage,
            package: pack,
            operationalDays: vanpool && vanpool.operationalDays,
            vanAvailableDays,
          },
          driver: {
            license: driver &&  `*****${driver.partialLicenseNumber}`,
            state: driver && driver.stateOfIssue
              ? standardizeStateCase(driver.stateOfIssue)
              : '',
            isDriver: profile && profile.roles.driver,
            licenseExpiry: driver && driver.expirationDate,
          },
          subscription: {
            subscriptionRate: subscriptionSummary ? subscriptionSummary.subscriptionRate : "",
            package: subscriptionSummary && subscriptionSummary.package,
            taxAmount: subscriptionSummary ? subscriptionSummary.taxAmount : "",
            participantRole: subscriptionAPIInfo && subscriptionAPIInfo.participantRole,
            vanpoolRates: subscriptionSummary && subscriptionSummary.vanpoolRates && subscriptionSummary.vanpoolRates[0] && subscriptionSummary.vanpoolRates[0].rates,
            isVanStartingInFuture,
            isVanCancelled,
            startDate: subscriptionAPIInfo && subscriptionAPIInfo.pendingChange && subscriptionAPIInfo.pendingChange.startDate,
            endDate: subscriptionAPIInfo && subscriptionAPIInfo.endDate,
            dashboardCommuteDays: presentOrPendingCommuteDays,
            totalAmount: subscriptionAPIInfo && subscriptionAPIInfo.totalAmount,
            isLastApprovedDriver: subscriptionAPIInfo?.isLastApprovedDriver || false,
          },
          employerName: commuteDetails && commuteDetails.employerName,
          employerId: commuteDetails && commuteDetails.employerId,
          isCoordinator: profile && profile.coordinatorStatus && profile.coordinatorStatus.includes('Approved'),
          isDriver:profile && profile.driverStatus && profile.driverStatus.includes('Approved'),
         // profileImage: participant ? participant.profileImage : "",
          driverStatus: profile && profile.driverStatus,
          driverMvrStatus: profile && profile.driverMvrStatus,
          driverUpdatedStatus: profile && getDriverStatus(profile.driverStatus),
          commuteDetails,
          phones: profile && profile.phones,
          rosterDays,
          paymentCards: subscriptionSummary ? subscriptionSummary.storedPaymentCards : [],
          subscriptionAPIInfo,
          isSubscription: user && user.isSubscription,
          fromProfile: fromProfile,
          employee: {
            isEmployeeIdRequired: profile.isEmployeeIdRequired,
            isEmployeeIdMissing: profile.isEmployeeIdMissing,
            employeeId: profile.employeeId,
            employeeIdPattern: profile.employeeIdPattern,
            employeeIdPatternDescription: profile.employeeIdPatternDescription
          },
          roles: profile && profile.roles
        }
      });
      if(notFromProfile) {
        yield put({type: actionTypes.LOADED_NOT_FROM_PROFILE});
      }
    }
    if(participant && participant.profileImage){
      yield put({
        type: actionTypes.LOAD_PROFILE_IMAGE,
        data: {
          profileImage: participant ? participant.profileImage : "",
        }
      });
    }
    if(subscriptionSummary){
      yield put({type: actionTypes.SUBSCRIPTION_SUMMARY_LOADED, data: subscriptionSummary});
    }

    if (action && action.resetAction) {
      yield put(action.resetAction);
    }

    const userInfo = userService.getUserProfile();
    var newProfile = userInfo.isSubscription ? userInfo && subscriptionAPIInfo && profileService.addSubscriptionPermissions(userInfo, subscriptionAPIInfo) : userInfo;
    if(userInfo && userInfo.isSubscription){
      newProfile = userInfo  && profileService.addSubscriptionTripPermissions(newProfile, profile);
    }
    newProfile = newProfile && profile && profileService.addProfilePermissions(newProfile, { ...profile, licenseExpiry: driver && driver.expirationDate });

    if(newProfile){
      yield put({type: actionTypes.SET_USER_AUTHORIZATION, data: newProfile});
      yield put({type: actionTypes.PROFILE_PERMISSION_COMPLETED, data: true});
    }

    if(commuteDetails){
      const mappedRouteResponse = {
        outboundRoutePoints: [
          {
            address: commuteDetails.originAddress,
            latitude: commuteDetails.originLatitude,
            longitude: commuteDetails.originLongitude,
            stopTime: commuteDetails.originDepartureTime,
            description: 'Home'
          },
          {
            address: commuteDetails.destinationAddress,
            latitude: commuteDetails.destinationLatitude,
            longitude: commuteDetails.destinationLongitude,
            stopTime: commuteDetails.destinationArrivalTime,
            description: commuteDetails.employerName
          }
        ],
        inboundRoutePoints: [
          {
            address: commuteDetails.destinationAddress,
            latitude: commuteDetails.destinationLatitude,
            longitude: commuteDetails.destinationLongitude,
            stopTime: commuteDetails.destinationDepartureTime,
            description: commuteDetails.employerName
          },
          {
            address: commuteDetails.originAddress,
            latitude: commuteDetails.originLatitude,
            longitude: commuteDetails.originLongitude,
            stopTime: commuteDetails.originArrivalTime,
            description: 'Home'
          }
        ]
      };
      yield put({
        type: actionTypes.PARTICIPANT_ROUTE_LOADED,
        data: mappedRouteResponse
      });
     const commute = {
        employer: commuteDetails.employerName || '',
        employerId: commuteDetails.employerId,
        activeDays: commuteDetails.commuteDays || [],
        arriveAtWork: commuteDetails.destinationArrivalTime || NA_VALUE,
        departFromWork: commuteDetails.destinationDepartureTime || NA_VALUE,
        homeAddress: commuteDetails.originAddress || NA_VALUE,
        workAddress: commuteDetails.destinationAddress || NA_VALUE,
        worksiteId: commuteDetails.worksiteId || undefined,
        arriveFlexible: commuteDetails.isWorkArriveTimeFlexible ? 10 : 0,
        departFlexible: commuteDetails.isWorkDepartTimeFlexible ? 10 : 0,
        isEditable: !!commuteDetails.isEditable
      }
      yield put({ type: actionTypes.COMMUTE_PROFILE_LOADED, data: {commute}});
    }
    if(vanpool && fromProfile){
      yield put({ type: actionTypes.VANPOOL_INFO_LOADED, data: vanpool });
    }

  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.USER_PROFILE_LOADING_ERROR, errorString: ex });
    if (action && action.history && action.source && action.source === 'joinCommute') {
      action.history.push('/JoinCommute/error');
    }
  }
}

function* loadStates() {
  try {
    const statesUrl = `${config.kongApiBaseUrl}/location/states`;

    const response = yield call(() => Http.get.cache(statesUrl));

    yield put({
      type: actionTypes.STATES_LOADED,
      data: response.states.map(state => standardizeStateCase(state.name))
    });
  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.STATES_LOADING_ERROR, data: [], errorString: ex });
  }
}

function* leaveVanpool({ data }) {
  try {
    const url = `${config.kongApiBaseUrl}/vanpools/vanpool/participant/${data}`;

  const response = yield call(() => Http.delete(url));

    yield put({ type: actionTypes.LEFT_VANPOOL, data: response.success });
  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.LEFT_VANPOOL, data: false });
  }
}

function* saveLicense({ data }) {
  try {
    const driverUrl = `${config.kongApiBaseUrl}/user/profile/license`;

    yield call(() =>
      Http.put(driverUrl, {
        licenseNumber: data.license,
        stateOfIssue: data.state
      })
    );
  } catch (ex) {
    logger.log(ex);
  }

  yield put({ type: actionTypes.USER_PROFILE_LOADING });
}

function* togglePreference({ data }) {
  try {
    const preferenceUrl = `${config.kongApiBaseUrl}/user/participant/profile/preferences`;

    const update = yield call(() =>
      Http.put(preferenceUrl, {
        preferences: [
          { preferenceCode: data.preferenceCode, isSelected: !data.isSelected }
        ]
      })
    );

    if (!update.success) {
      yield put({
        type: actionTypes.DISPLAY_ERROR,
        data: 'Unable to update preference.'
      });
      yield put({ type: actionTypes.RESET_PREFERENCE, data });
    }
    yield put({ type: actionTypes.PREFERENCE_CHANGED});
  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.RESET_PREFERENCE, data });
    yield put({ type: actionTypes.PREFERENCE_CHANGE_ERROR });
  }
}

function standardizeStateCase(state) {
  if(state){
    return state
    .split(' ')
    .map(word => word[0].toUpperCase() + word.substr(1).toLowerCase())
    .join(' ');
  }
}

function* getVanpoolRatesInfo() {
  try {
    const state = yield select();
    let response = yield call(() =>
      Http.get(subscriptionURL, { vanpoolId: state.profile.vanpoolId })
    );
    if (response && response.vanpool && response.vanpool.vanpoolRates) {
      yield put({ type: actionTypes.SET_VANPOOL_RATES_INFO, data: response.vanpool.vanpoolRates });
    }
  }
  catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.SET_VANPOOL_RATES_INFO, data: {} });
  }
}

function* applyToDrive(action) {
  try {
    const state = yield select();
    const contractInfo = state.joinCommute.contractInfo;
    if (state && state.profile && state.profile.driverApplicationData && state.profile.driverApplicationData.apiData) {
      var payload = state.profile.driverApplicationData.apiData;
      payload.driverCoordInformation.agreementId = contractInfo.agreementId ? contractInfo.agreementId : null;
      payload.driverCoordInformation.clickwrapId = contractInfo.clickwrapId ? contractInfo.clickwrapId : null;
      const resp = yield call(() => Http.post(subscriptionURL, payload));
      if (resp && resp.success) {
        yield put({ type: actionTypes.SUBSCRIPTION_CHANGED });
        if (action && action.history && action.navigateTo) {
          action.history.push(action.navigateTo);
        }
      }else{
        yield put({ type: actionTypes.APPLY_TO_DRIVE_FAILURE });
      }
    }
  }
  catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.APPLY_TO_DRIVE_FAILURE });
  }
}

function* submitCoordinatorApplication(action) {
  try {
    const state = yield select();
    const contractInfo = state.joinCommute.contractInfo;
    var payload = action.data;
    payload.agreementId = contractInfo.agreementId ? contractInfo.agreementId : null;
    payload.clickwrapId = contractInfo.clickwrapId ? contractInfo.clickwrapId : null;
    const resp = yield call(() => Http.post(coordApplication, payload));
    // yield delay(2000);
    // const resp = {success: true};
    if (resp && resp.success) {
      if(action.application == 'coordinator'){
        action.history.push("/coordinator-application/Thankyou");
      }else {
        action.history.push("/driver-application/Thankyou");
      }
    }
  }
  catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.DRIVER_COORDINATOR_APPLICATION_FAILED, data: true });
  }
}

function* updateLicense(action) {
  try {
    const state = yield select();
    const updateURL = `${config.kongApiBaseUrl}/user/profile/license`;
    if (action.data && state.profile && state.profile.vanpoolId) {
      const response =  yield call(() =>
        Http.put(updateURL, action.data, { vanpoolId: state.profile.vanpoolId, participantId: 'P-046098' })
      );
      // const response = {success: true}
      if(response && response.success){
        yield delay(3000);
        yield put({ type: actionTypes.UPDATE_USER_PROFILE_DATA });
        yield put({ type: actionTypes.UPDATE_LICENSE_SUCCESS });
      }
    }
  }
  catch (ex) {
    logger.log(ex);
  }
}

function* cancelSubscription(action) {
  try {
    const cancelSubscriptionURL = `${config.kongApiBaseUrl}/vanpools/vanpool/cancelSubscription`;
    const state = yield select();
    const profile = state && state.profile;
    const lastDayRiding = profile && profile.subscription && profile.subscription.lastDay;
    const reasonID = profile && profile.subscription && profile.subscription.cancellationReasonID;
    const reasonObject = cancelReasons[reasonID];
    const reason = reasonObject && reasonObject.reason;
    const request = {
      lastDayRiding,
      reason
    }
    const response = yield call(() => Http.post(cancelSubscriptionURL, request));
    // yield delay(1000);
    // const response = {
    //   "success": true,
    //   "subscriptionEndDate": "2024-10-24",
    //   "lastDayRiding": "2024-09-25"
    // }
    if (response?.success) {
      yield put({ type: actionTypes.CANCEL_SUBSCRIPTION_SUCCESS, ...response });
    }

  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.CANCEL_SUBSCRIPTION_FAILED });
  }
}

function* changeCommuteDays(action) {
  try {
    const contractUrl = `${config.kongApiBaseUrl}/user/participant/agreement`;
    const vanpoolId = action.data.vanpoolId;
    var paylaod = {
      "isDriver": action.data.isDriver
    }
    const contractResponse = yield call(() => Http.post(contractUrl, paylaod, { vanpoolId }));
    if (contractResponse && contractResponse.agreementId && contractResponse.isAgreed) {
      const response = yield call(() => Http.post(subscriptionURL, { ...action.data, agreementId: contractResponse.agreementId, clickwrapId: contractResponse.clickwrapId }));
      if (response && response.success) {
        yield put({ type: actionTypes.CHANGE_COMMUTE_DAYS_SUCCESS });
        yield put({ type: actionTypes.CHANGE_COMMUTE_DAYS_CHANGING, data: false});
      }
    }
  } catch (ex) {
    logger.log(ex);
  }
}

function* getSubscriptionDetails() {
  try {
    let response = yield call(() =>
      Http.get(subscriptionURL)
    );
    if (response) {
      yield put({ type: actionTypes.SET_SUBSCRIPTION_DETAILS, data: response });
    }
  }
  catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.SET_SUBSCRIPTION_DETAILS, data: null });
  }
}

function* changeSubscriptionType(action) {
  try {
    const response = yield call(() => Http.post(subscriptionURL, action.data));
    if (response && response.success) {
      // yield delay(3000);
      yield put({ type: actionTypes.CHANGE_SUBSCRIPTION_TYPE_SUCCESS });
    }
  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.CHANGE_SUBSCRIPTION_TYPE_FAILURE });
  }
}

function getDriverStatus(data){
  if(!data){
    return null
  }
  var status = data.toLowerCase()
  if(status === 'approved' || status === 'expiring' || status === 'expiring today' || status === 'expiring license') {
    return null;
  } else if (status === 'pending' || status === 'pending application' || status === 'pending approval' || status === 'pending mvr' || status.includes("exception")) {
    return "Pending Driver Approval";
  } else if(status === 'expired' || status === 'expired license') {
    return "License Expired";
  } else if(status === 'declined'){
    return "Non-Approved Driver";
  }
}


function* saveUserCommuteProfile(action) {
  var data = action.data;
  const commuteUrl = `${config.kongApiBaseUrl}/user/profile/commuteProfile`;
  const profile = userService.getUserProfile();
  const userInfo = userService.getAuthentication();

  try {
    const durationsAction = yield take(actionTypes.MAP_PROFILE_DURATIONS);
    const duration = durationsAction.data[0];
    const originDepartureTime = dateUtility.shiftBySeconds(
      data.arriveTime,
      -duration
    );
    const originArrivalTime = dateUtility.shiftBySeconds(
      data.departTime,
      duration
    );
      let payload = {
        referralChannel: 'Friend',
        phone: profile.phone,
        defaultTransportationModeId: 2,
        originLatitude: data.homeLatitude,
        originLongitude: data.homeLongitude,
        originArrivalTime: originArrivalTime,
        originDepartureTime: originDepartureTime,
        originAddress: data.homeAddress ? data.homeAddress : null,
        destinationAddress: data.workAddress ? data.workAddress : null,
        destinationArrivalTime: data.arriveTime,
        destinationLongitude: data.workLongitude,
        destinationLatitude: data.workLatitude,
        destinationDepartureTime: data.departTime,
        employerName: data.employerName ? data.employerName : null,
        profileId: userInfo.profileId,
        isAllowNotifyCommuteMatch: false,
        isWorkDepartTimeFlexible: data.flexArrivalMinutes
          ? data.flexArrivalMinutes
          : false,
        worksiteId: null,
        employerId: data.employerId,
        commuteDays:data.activeDays,
        isWorkArriveTimeFlexible: data.flexDepartureMinutes
          ? data.flexDepartureMinutes
          : false
      };
   var response = yield call(() => Http.put(commuteUrl, payload));
    if(response.success) {
      yield put({ type: actionTypes.COMMUTE_USER_PROFILE_SAVED, data: true });
      yield put({ type: actionTypes.COMMUTE_PROFILE_LOADING });
    }

  } catch (ex) {
    yield put({ type: actionTypes.COMMUTE_USER_PROFILE_SAVED, data: true });
    yield put({ type: actionTypes.COMMUTE_PROFILE_LOADING });
    logger.log(ex);
  }
}

function* refreshAuthentication(action) {
  try {
    const [userProfile, registration] = yield all([
      call(() => Http.get(`${config.kongApiBaseUrl}/user/loginProfile`)),
      call(() =>
        Http.get(`${config.kongApiBaseUrl}/user/profile/registration/status`)
      )
    ]);
    userProfile.registration = registration;
    const loginProfile = profileService.generateProfile(userProfile);
    yield put({ type: actionTypes.SET_USER_AUTHORIZATION, data: loginProfile });
    yield put({ type: actionTypes.SET_REFRESH_DASHBOARD, refresh: true });
    yield put({ type: actionTypes.REFRESH_AUTHENTICATION_AND_REDIRECT_REFRESH, refresh: false });
    action.history.push("/dashboard");
    return loginProfile;
  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.AUTHENTICATION_ERROR, data: ex });
  }
}


function* checkSecondaryCardIsRequired(action) {
  const url = `${config.kongApiBaseUrl}/vanpools/vanpool/update/subscription/summary`;
  const userInfo = userService.getAuthentication();
  var payload = {
    "subscriptionType": "Fixed",
    "packageName": action.data.packageName,
    "packageDiscountType": action.data.packageDiscountType,
    "employerId": action.data.employerId,
    // "vanpoolId": action.data.vanpoolId,
    // "profileId": userInfo.profileId
  }
  try {
    const response = yield call(() => Http.post(url, payload));
    if (response && response.isRetailRequiredForRecurringPayment) {
      yield put({ type: actionTypes.SECONDARY_CARD_IS_REQUIRED, data: {isRequired: true, checkCompleted: true, checkError: false} });
    } else {
      yield put({ type: actionTypes.SECONDARY_CARD_IS_REQUIRED, data:  {isRequired: false, checkCompleted: true, checkError: false} });
    }
  } catch (ex) {
    logger.log(ex);
    yield put({ type: actionTypes.SECONDARY_CARD_IS_REQUIRED, data:  {isRequired: false, checkCompleted: true, checkError: true} });
  }
}